export default "__VITE_ASSET__BdoHLPKy__"